import React from 'react';
import { MapPin, PawPrint } from 'lucide-react';
import { SERVICE_AREAS, CONTACT } from '../data/mock';

const ServiceArea = () => {
  return (
    <section className="py-20 lg:py-24 bg-[#faf5fb]">
      <div className="max-w-[1280px] mx-auto px-5 lg:px-10">
        <div className="grid lg:grid-cols-[1fr_1.2fr] gap-12 items-center">
          <div>
            <span className="inline-flex items-center gap-2 text-[#e870b6] font-semibold tracking-[0.2em] text-[13px] uppercase mb-3">
              <PawPrint size={16} /> Service Areas
            </span>
            <h2 className="font-serif text-[36px] lg:text-[48px] font-extrabold text-[#1a0b3d] leading-tight mb-5">
              Caring for pets across the NCR
            </h2>
            <p className="text-slate-600 leading-relaxed mb-7">
              Conveniently located at <span className="text-[#5b3eb5] font-semibold">{CONTACT.shortAddress}</span>, we welcome pet parents from across Noida and neighbouring cities. Trusted, local pet care just minutes from your home.
            </p>
            <div className="flex flex-wrap gap-2">
              {SERVICE_AREAS.map((area) => (
                <span
                  key={area}
                  className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-white border border-[#f3d6f5] text-[#5b3eb5] text-[13px] font-medium hover:bg-[#5b3eb5] hover:text-white hover:border-[#5b3eb5] transition-colors cursor-default"
                >
                  <MapPin size={13} /> {area}
                </span>
              ))}
            </div>
          </div>

          <div className="rounded-3xl overflow-hidden shadow-2xl border border-[#f3d6f5]/50 aspect-[4/3] bg-white">
            <iframe
              title="Ichi and Ori Pet Care Location"
              src={CONTACT.mapsEmbed}
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceArea;
